import React from "react";
import loader from "../../assets/images/logo.svg"
import shoperLoader from "../../assets/images/shoper_logo.png"
import { isShoperApp } from "../../util/appType";
import { useAuth0 } from "../../react-auth0-spa";

const CircularProgress = ({className}) => {
    const {isAuthenticated} = useAuth0();

    return <div className={`loader wm-loader ${className}`}>
        {/* Shoper signs in without Auth0: show its loader there too, or loading pages are blank */}
        {(isAuthenticated || isShoperApp()) && (isShoperApp()
            ? <img src={shoperLoader} alt="loader"/>
            : <>
                <img className="wm-loader__logo wm-loader__logo--light" src={loader} alt="loader"/>
                {/* "way" in logo.svg is dark grey and disappears on a dark background */}
                <img className="wm-loader__logo wm-loader__logo--dark" src="/logo-dark.svg" alt=""/>
            </>)}
    </div>
};

export default CircularProgress;
